import httpClient from '../httpClient';

export async function getAllOrgInterCotacao() {
  try {
    const response = await httpClient.get(`/api/orginter-cotacao`);

    // Verifica se response.data existe antes de acessar registros
    if (!response.data || !Array.isArray(response.data.registros)) {
      console.warn('API retornou um formato inesperado:', response.data);
      return [];
    }

    return response.data.registros;
  } catch (error) {
    console.error('Erro ao obter dados:', error);
    return []; // Retorna array vazio para evitar erros no .map()
  }
}

export async function getOrgInterCotacao(id: string) {
  try {
    const response = await httpClient.get(`/api/orginter-cotacao/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter dados: ' + error);
  }
}

export async function getCotacaoPorOrgInter(id: string) {
  try {
    const response = await httpClient.get(
      `/api/orginter-cotacao/orginter/${id}`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter dados: ' + error);
  }
}

export async function getCotacaoPorTermoReferencia(id: string) {
  try {
    const response = await httpClient.get(
      `/api/orginter-cotacao/termoreferencia/${id}`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter dados: ' + error);
  }
}
